import React from 'react';
import { Package } from 'lucide-react';
import MagasinBadge from '../../components/MagasinBadge';
import { fmtEuro, stockPhotoUrl, stockStatusBadge } from './stockUtils';

const StockArticleListCard = ({ article, selected, promo, onSelect, isAdmin, bulkSelected, onToggleBulk }) => {
  const tone = stockStatusBadge(article.quantite, article.seuil_alerte, article.quantite_depot);
  const thumb = stockPhotoUrl(article.thumbnail_url || article.photo_url);

  return (
    <article
      role="button"
      tabIndex={0}
      onClick={onSelect}
      onKeyDown={(e) => e.key === 'Enter' && onSelect?.()}
      className={`rounded-xl border p-3 flex gap-3 shrink-0 overflow-hidden w-full min-w-0 cursor-pointer transition ${
        selected ? 'border-red-500/50 bg-[#1a1f2a]' : 'border-white/10 bg-[#151820] hover:border-white/20'
      }`}
      data-testid={`stock-card-${article.id}`}
    >
      {isAdmin && (
        <div className="shrink-0 flex items-start pt-1">
          <input
            type="checkbox"
            checked={!!bulkSelected}
            onChange={() => onToggleBulk?.(article.id)}
            onClick={(e) => e.stopPropagation()}
            className="w-4 h-4 rounded"
            aria-label="Sélectionner pour action groupée"
          />
        </div>
      )}
      <div className="shrink-0 w-16 h-16 rounded-lg bg-black/40 border border-white/10 overflow-hidden flex items-center justify-center">
        {thumb ? (
          <img src={thumb} alt="" className="w-full h-full object-contain p-1" />
        ) : (
          <Package size={20} className="text-gray-600" />
        )}
      </div>
      <div className="flex-1 min-w-0 flex flex-col gap-1.5">
        <div className="min-w-0">
          <p className="text-[10px] text-gray-400 font-mono truncate">{article.reference}</p>
          <p className="text-sm font-semibold text-white line-clamp-2 leading-snug mt-0.5">{article.designation}</p>
        </div>
        <div className="flex items-center gap-1.5 flex-wrap">
          <MagasinBadge code={article.magasin_id || 'M1'} size="sm" />
          <span className={`px-2 py-0.5 rounded-full text-[10px] font-bold border ${tone.className}`}>{tone.label}</span>
        </div>
        <div className="flex items-end justify-between gap-2 pt-1.5 mt-auto border-t border-white/5 min-w-0">
          <div className="text-[10px] text-gray-500 truncate">
            Bout. {article.quantite ?? 0} · Dép. {article.quantite_depot ?? 0}
          </div>
          <span className="text-sm font-bold text-red-400 shrink-0 whitespace-nowrap tabular-nums">
            {promo ? (
              <>
                <span className="text-[10px] text-gray-500 line-through mr-1">{fmtEuro(article.prix_vente)}</span>
                {fmtEuro(promo.effective_price)} €
              </>
            ) : (
              `${fmtEuro(article.prix_vente)} €`
            )}
          </span>
        </div>
      </div>
    </article>
  );
};

export default StockArticleListCard;
